module.exports = __webpack_public_path__ + "static/media/project3.54e67f6a.jpeg";